export const searchToQuery = (search: string): URLSearchParams | undefined => {
  if (!search || Object.prototype.toString.call(search) !== '[object String]') {
    return
  }
  if (search[0] === '?') {
    return new URLSearchParams(search.substr(1, search.length))
  } else {
    return new URLSearchParams(search)
  }
}

export const generatorUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const parseSearch = () => {
  const query = new URLSearchParams(location.search)
  const json: Record<string, string> = {}
  query.forEach((value, key) => {
    json[key] = value
  })
  return json
}
